export default __webpack_public_path__ + "static/joe-food-0a26b88f99e8f6f4cefe0f11f0e3e2af.jpg";